<template>
  <div>
    <van-nav-bar style="top: 0;position: fixed;width: 100%;">
      <template #left>
        <van-dropdown-menu>
          <van-dropdown-item v-model="afterFee" :options="showTypeOptions"/>
        </van-dropdown-menu>
      </template>
      <template #title>
        <a style="font-size: 12px;color: rgb(24, 144, 255)" @click="backToPC">返回PC端</a>
      </template>
      <template #right>
        <van-dropdown-menu>
          <van-dropdown-item v-model="initPage.orderBy" :options="orderOptions" @change="queryItemList"/>
        </van-dropdown-menu>
      </template>
    </van-nav-bar>
    <div style="background-color: #fafafa;padding-top: 55px;">
      <!--      筛选条件-->
      <div style="margin-bottom: 8px">
        <div style="display: flex">
          <div
            style="font-size: 14px;line-height:24px;margin:0 12px;color: #646566;text-align: left;word-wrap: break-word;">
            快捷筛选:
          </div>
          <van-tag type="primary" size="medium" style="margin: 0 4px" @click="quickFilter('weaponCase')">
            武器箱数据
          </van-tag>
          <van-tag type="primary" size="medium" style="margin: 0 4px" @click="quickFilter('stickerCapluse')">
            胶囊数据
          </van-tag>
        </div>
        <van-search show-action @search="queryItemList" v-model="initPage.name" placeholder="请输入搜索关键词">
          <template #action>
            <div @click="queryItemList">搜索</div>
          </template>
        </van-search>
        <van-row>
          <van-col span="12">
            <van-field
              label-width="5em"
              clickable
              v-model="initPage.last24Volume"
              name="成交数量 ≥"
              label="成交数量 ≥"
              placeholder="近期成交数量大于等于"
            />
          </van-col>
          <van-col span="12">
            <van-field
              label-width="5em"
              clickable
              v-model="initPage.minPrice"
              name="最低求购价"
              label="最低求购价"
              placeholder="Steam最低求购价大于等于"
            />
          </van-col>
        </van-row>


      </div>
      <!--      数据展示-->
      <van-pull-refresh v-model="loading" @refresh="queryItemList">
        <van-skeleton style="padding-top: 55px" v-if="loading" title :row="24"/>
        <div style="height: 100%;overflow: auto" v-else>
          <div v-for="(staff,index) of staffList" style="margin-bottom: 8px">
            <van-cell-group inset>
              <van-cell style="font-size: 12px;align-items: center">
                <template #title>
                  <div style="color: #1890ff;cursor: pointer" v-clipboard="staff.staffName">
                    {{ index + 1 + initPage.limit * (initPage.offset - 1) }}. {{ staff.staffName }}
                  </div>
                </template>
                <template #right-icon>
                  <van-button size="small" type="default" @click="showDetailPopup(staff)">趋势</van-button>
                </template>
              </van-cell>
              <van-card
                style="min-height: 60px;background-color: white"
                :key="staff.engName"
              >
                <!--                <template #thumb>-->
                <!--                  <div :class="staff.staffGame === 'csgo' ? 'image-container':''">-->
                <!--                    <img style="width: 105px;height: 100%" :src="staff.iconUrl"/>-->
                <!--                  </div>-->
                <!--                  <div style="margin-top: 10px;text-align: center;">-->
                <!--                    近期成交 {{ staff.volume }} 件-->
                <!--                  </div>-->
                <!--                </template>-->
                <template #desc>
                  <div style="border-spacing: 0 5px;">
                    <table id="table-1" style="table-layout: fixed;border: none">
                      <tr>
                        <th class="van-th" align="center">BUFF</th>
                        <th class="van-th" align="center">悠悠有品</th>
                        <th class="van-th" align="center">C5Game</th>
                        <th class="van-th" align="center">IGXE</th>
                      </tr>
                      <tr>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice === staff.buffPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://buff.163.com/goods/${staff.buffId}?utm_source=hangKnife.com`)"
                        >
                          <span v-if="staff.buffPrice"> {{ staff.buffPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice === staff.uupinPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://www.youpin898.com/goodInfo?id=${staff.uupinId}&utm_source=hangKnife.com`)"
                        >
                          <span v-if="staff.uupinPrice"> {{ staff.uupinPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice === staff.c5Price ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://www.c5game.com/${staff.staffGame}/${staff.c5Id}/${staff.engName}/sell?utm_source=hangKnife.com`)"
                        >
                          <span v-if="staff.c5Price"> {{ staff.c5Price }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice === staff.igxePrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://www.igxe.cn/product/${staff.staffGame == 'dota2' ? 570:730}/${staff.igxeId}?utm_source=hangKnife.com`)"
                        >
                          <span v-if="staff.igxePrice"> {{ staff.igxePrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                      </tr>
                      <tr>
                        <th class="van-th" align="center">ECO</th>
                        <th class="van-th" align="center">V5Item</th>
                        <th class="van-th" align="center">SkinPort</th>
                        <th class="van-th" align="center">DMarket</th>
                      </tr>
                      <tr>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice == staff.ecoPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://www.ecosteam.cn/goods/730-${staff.ecoId}-1-laypagesale-0-1.html?utm_source=hangKnife.com`)"
                        >
                          <span v-if="staff.ecoPrice"> {{ staff.ecoPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice == staff.v5ItemPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://v5item.com/goods/${staff.engName}?tabbar=0&utm_source=hangKnife.com`)"
                        >
                          <span v-if="staff.v5ItemPrice"> {{ staff.v5ItemPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice == staff.skinPortPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://skinport.com/zh${staff.staffGame === 'csgo' ? '/' : '/dota2/'}market?search=${staff.engName}&sort=price&order=asc`)"
                        >
                          <span v-if="staff.skinPortPrice"> {{ staff.skinPortPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice == staff.dmarketPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(formatterDmarketUrl(staff))"
                        >
                          <span v-if="staff.dmarketPrice"
                          > {{
                              staff.dmarketPrice == null ? null : staff.dmarketPrice.toFixed(2)
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                      </tr>
                      <tr>
                        <th class="van-th" align="center">BitSkins</th>
                        <th class="van-th" align="center">Waxpeer</th>
                        <th class="van-th" align="center">HaloSkins</th>
                      </tr>
                      <tr>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice === staff.bitSkinsPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(formatSkinNameToURL(staff.staffGame == 'csgo' ? 'cs2':'dota2',staff.engName))"
                        >
                          <span v-if="staff.bitSkinsPrice"> {{
                              staff.bitSkinsPrice == null ? '' : staff.bitSkinsPrice.toFixed(2)
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice == staff.waxpeerPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(`https://www.waxpeer.com/r/hangknife?game=csgo&sort=ASC&order=price&all=0&search=${staff.engName}&exact=1`)"
                        >
                          <span v-if="staff.waxpeerPrice"> {{ staff.waxpeerPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center"
                            :style="staff.minPlatformPrice == staff.haloPrice ? 'background-color: #E6A23C':''"
                            @click="routerChanger(staff.haloUrl)"
                        >
                          <span v-if="staff.haloPrice"> {{ staff.haloPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                      </tr>
                      <tr v-if="afterFee === 0 || afterFee === 1">
                        <th class="van-th" align="center"
                            @click="routerChanger(`https://steamcommunity.com/market/listings/${staff.staffGame == 'dota2' ? 570:730}/${staff.engName}`)"
                        >
                          <div style="display: flex;align-items: center">
                            <svg t="1723644064789" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="4277" width="16" height="16">
                              <path
                                d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 64c194.08 0 352 157.92 352 352s-157.92 352-352 352c-163.488 0-300.832-112.192-340.256-263.488l117.312 50.24A95.68 95.68 0 0 0 384 736a96 96 0 0 0 96-96c0-1.024-0.288-2.016-0.32-3.008l133.696-93.504A127.744 127.744 0 0 0 736 416a128 128 0 0 0-128-128 127.68 127.68 0 0 0-127.424 122.624l-93.568 133.696c-1.024-0.032-1.984-0.32-3.008-0.32-21.216 0-40.64 7.104-56.576 18.752l-166.368-71.328C171.84 306.944 324.864 160 512 160z m96 160a96 96 0 1 1 0 192 96 96 0 0 1 0-192z m0 32a64 64 0 0 0 0 128 64 64 0 0 0 0-128z m-224 224a64 64 0 1 1-58.112 90.496l25.056 10.752a48.096 48.096 0 0 0 63.04-25.184 48 48 0 0 0-25.248-63.008l-23.296-9.984c5.92-1.824 12.064-3.072 18.56-3.072z"
                                p-id="4278"></path>
                            </svg>
                            {{ afterFee ? '近期到手' : '近期成交' }}
                          </div>
                        </th>
                        <th class="van-th" align="center"
                            @click="routerChanger(`https://steamcommunity.com/market/listings/${staff.staffGame == 'dota2' ? 570:730}/${staff.engName}`)"
                        >
                          <div style="display: flex;align-items: center">
                            <svg t="1723644064789" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="4277" width="16" height="16">
                              <path
                                d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 64c194.08 0 352 157.92 352 352s-157.92 352-352 352c-163.488 0-300.832-112.192-340.256-263.488l117.312 50.24A95.68 95.68 0 0 0 384 736a96 96 0 0 0 96-96c0-1.024-0.288-2.016-0.32-3.008l133.696-93.504A127.744 127.744 0 0 0 736 416a128 128 0 0 0-128-128 127.68 127.68 0 0 0-127.424 122.624l-93.568 133.696c-1.024-0.032-1.984-0.32-3.008-0.32-21.216 0-40.64 7.104-56.576 18.752l-166.368-71.328C171.84 306.944 324.864 160 512 160z m96 160a96 96 0 1 1 0 192 96 96 0 0 1 0-192z m0 32a64 64 0 0 0 0 128 64 64 0 0 0 0-128z m-224 224a64 64 0 1 1-58.112 90.496l25.056 10.752a48.096 48.096 0 0 0 63.04-25.184 48 48 0 0 0-25.248-63.008l-23.296-9.984c5.92-1.824 12.064-3.072 18.56-3.072z"
                                p-id="4278"></path>
                            </svg>
                            {{ afterFee ? '寄售到手' : '寄售价格' }}
                          </div>
                        </th>
                        <th class="van-th" align="center"
                            @click="routerChanger(`https://steamcommunity.com/market/listings/${staff.staffGame == 'dota2' ? 570:730}/${staff.engName}`)"
                        >
                          <div style="display: flex;align-items: center">
                            <svg t="1723644064789" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="4277" width="16" height="16">
                              <path
                                d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 64c194.08 0 352 157.92 352 352s-157.92 352-352 352c-163.488 0-300.832-112.192-340.256-263.488l117.312 50.24A95.68 95.68 0 0 0 384 736a96 96 0 0 0 96-96c0-1.024-0.288-2.016-0.32-3.008l133.696-93.504A127.744 127.744 0 0 0 736 416a128 128 0 0 0-128-128 127.68 127.68 0 0 0-127.424 122.624l-93.568 133.696c-1.024-0.032-1.984-0.32-3.008-0.32-21.216 0-40.64 7.104-56.576 18.752l-166.368-71.328C171.84 306.944 324.864 160 512 160z m96 160a96 96 0 1 1 0 192 96 96 0 0 1 0-192z m0 32a64 64 0 0 0 0 128 64 64 0 0 0 0-128z m-224 224a64 64 0 1 1-58.112 90.496l25.056 10.752a48.096 48.096 0 0 0 63.04-25.184 48 48 0 0 0-25.248-63.008l-23.296-9.984c5.92-1.824 12.064-3.072 18.56-3.072z"
                                p-id="4278"></path>
                            </svg>
                            {{ afterFee ? '求购到手' : '求购价格' }}
                          </div>
                        </th>
                        <th class="van-th" align="center"
                            @click="routerChanger(`https://steamcommunity.com/market/listings/${staff.staffGame == 'dota2' ? 570:730}/${staff.engName}`)"
                        >
                          <div style="display: flex;align-items: center">
                            <svg t="1723644064789" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="4277" width="16" height="16">
                              <path
                                d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 64c194.08 0 352 157.92 352 352s-157.92 352-352 352c-163.488 0-300.832-112.192-340.256-263.488l117.312 50.24A95.68 95.68 0 0 0 384 736a96 96 0 0 0 96-96c0-1.024-0.288-2.016-0.32-3.008l133.696-93.504A127.744 127.744 0 0 0 736 416a128 128 0 0 0-128-128 127.68 127.68 0 0 0-127.424 122.624l-93.568 133.696c-1.024-0.032-1.984-0.32-3.008-0.32-21.216 0-40.64 7.104-56.576 18.752l-166.368-71.328C171.84 306.944 324.864 160 512 160z m96 160a96 96 0 1 1 0 192 96 96 0 0 1 0-192z m0 32a64 64 0 0 0 0 128 64 64 0 0 0 0-128z m-224 224a64 64 0 1 1-58.112 90.496l25.056 10.752a48.096 48.096 0 0 0 63.04-25.184 48 48 0 0 0-25.248-63.008l-23.296-9.984c5.92-1.824 12.064-3.072 18.56-3.072z"
                                p-id="4278"></path>
                            </svg>
                            {{ afterFee ? '稳定到手' : '稳定成交' }}
                          </div>
                        </th>
                      </tr>
                      <tr v-if="afterFee === 0 || afterFee === 1">
                        <th class="van-th" align="center">
                          <span v-if="staff.steamAvgPrice">
                            {{
                              afterFee ? (staff.steamAvgPrice / 1.15).toFixed(2) : staff.steamAvgPrice
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center">
                          <span v-if="staff.steamSellerPrice"> {{
                              afterFee ? (staff.steamSellerPrice / 1.15).toFixed(2) : staff.steamSellerPrice
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center">
                          <span v-if="staff.steamBuyerPrice"> {{
                              afterFee ? (staff.steamBuyerPrice / 1.15).toFixed(2) : staff.steamBuyerPrice
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center">
                          <span v-if="staff.steamSafeBuyerPrice"> {{
                              afterFee ? (staff.steamSafeBuyerPrice / 1.15).toFixed(2) : staff.steamSafeBuyerPrice
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                      </tr>
                      <tr v-if="afterFee === 0 || afterFee === 1">
                        <th class="van-th" align="center">
                          <van-tag plain :type="formatterTagType(staff.avgPriceDisCount)" size="small"
                                   v-if="staff.avgPriceDisCount">
                            {{
                              afterFee ? (staff.avgPriceDisCount * 1.15).toFixed(3) : staff.avgPriceDisCount.toFixed(3)
                            }}
                          </van-tag>
                        </th>
                        <th class="van-th" align="center">
                          <van-tag plain :type="formatterTagType(staff.lowestDisCount)" size="small"
                                   v-if="staff.lowestDisCount">
                            {{ afterFee ? (staff.lowestDisCount * 1.15).toFixed(3) : staff.lowestDisCount.toFixed(3) }}
                          </van-tag>
                        </th>
                        <th class="van-th" align="center">
                          <van-tag plain :type="formatterTagType(staff.buyerPriceDisCount)" size="small"
                                   v-if="staff.buyerPriceDisCount">
                            {{
                              afterFee ? (staff.buyerPriceDisCount * 1.15).toFixed(3) : staff.buyerPriceDisCount.toFixed(3)
                            }}
                          </van-tag>
                        </th>
                        <th class="van-th" align="center">
                          <van-tag plain :type="formatterTagType(staff.safeBuyerPriceDisCount)" size="small"
                                   v-if="staff.safeBuyerPriceDisCount">
                            {{
                              afterFee ? (staff.safeBuyerPriceDisCount * 1.15).toFixed(3) : staff.safeBuyerPriceDisCount.toFixed(3)
                            }}
                          </van-tag>
                        </th>
                      </tr>
                      <tr v-if="afterFee === 2">
                        <th class="van-th" align="center">
                          <div style="display: flex;align-items: center">
                            <i style="margin-right: 4px" class="icon-buff iconfont icon-guanfangmeiti mr-5 text-26"
                               data-v-dcd5bfb1=""></i>
                            求购价
                          </div>
                        </th>
                        <th class="van-th" align="center">
                          <div style="display: flex;align-items: center">
                            <i style="margin-right: 4px" class="icon-youpin iconfont icon-guanfangmeiti mr-5 text-26"
                               data-v-dcd5bfb1=""></i>
                            求购价
                          </div>
                        </th>
                        <th class="van-th" align="center">
                          <div style="display: flex;align-items: center">
                            <img style="width: 12px;margin-right: 4px" src="../../../static/imgs/igxe.png"/> 求购价
                          </div>
                        </th>
                        <th class="van-th" align="center">
                          <div style="display: flex;align-items: center">
                            <i style="margin-right: 4px" class="icon-dmarket iconfont icon-guanfangmeiti mr-5 text-26"
                               data-v-dcd5bfb1=""></i>
                            求购价
                          </div>
                        </th>
                      </tr>
                      <tr v-if="afterFee === 2">
                        <th class="van-th" align="center">
                          <span v-if="staff.buffBuyOrderPrice">{{ staff.buffBuyOrderPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center">
                          <span v-if="staff.uupinBuyerPrice">{{ staff.uupinBuyerPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center">
                          <span v-if="staff.igxeBuyerPrice">{{ staff.igxeBuyerPrice }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>
                        <th class="van-th" align="center">
                          <span v-if="staff.dmarketOrderPrice">   {{
                              staff.dmarketOrderPrice == null ? '' : staff.dmarketOrderPrice.toFixed(2)
                            }}</span>
                          <span v-else style="font-size: 12px;color: #aaaaaa">{{ $t('noData') }}</span>
                        </th>

                      </tr>
                    </table>

                  </div>
                </template>
              </van-card>
            </van-cell-group>
          </div>
        </div>
        <van-pagination v-show="!loading" @change="queryItemList" v-model="initPage.offset"
                        :total-items="initPage.total" :items-per-page="initPage.limit"/>
      </van-pull-refresh>
    </div>
    <van-popup v-model="showDetail" position="bottom">
      <div style="padding: 8px;font-size: 14px;text-align: center">
        <van-tag style="margin-right: 8px" type="primary">
          {{ itemData.rarityName }}
        </van-tag>
        {{ itemData.cnName }}
      </div>
      <div style="max-height: 600px;overflow:auto;">
        <div id="priceEchartsContainer" style="height: 280px;margin-bottom: 8px"></div>
        <div id="detailEchartsContainer" style="height: 280px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import 'vant/lib/index.css';
import Vue from 'vue';

import {NavBar} from 'vant';
import {Skeleton} from 'vant';
import {Card} from 'vant';
import {Cell, CellGroup} from 'vant';
import {Icon} from 'vant';
import {Tag} from 'vant';
import {Pagination} from 'vant';
import {PullRefresh} from 'vant';
import {DropdownMenu, DropdownItem} from 'vant';
import {Button} from 'vant';
import {Search} from 'vant';
import {Form} from 'vant';
import {Field} from 'vant';
import {Popup} from 'vant';
import {Tab, Tabs} from 'vant';

import {auditDailyInfo, queryItemList} from "../../api/api";
import * as echarts from "echarts";
import {Col, Row} from 'vant';
import i18n from "../../main";

Vue.use(Card);
Vue.use(Skeleton);
Vue.use(NavBar);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Tag);
Vue.use(Pagination);
Vue.use(PullRefresh);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button);
Vue.use(Search);
Vue.use(Form);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Col);
Vue.use(Row);


export default {
  name: "mobileTable",
  data() {
    return {
      afterFee: 0,
      showTypeOptions: [
        {value: 0, text: 'Steam税前价格'},
        {value: 1, text: 'Steam到手余额'},
        {value: 2, text: '平台求购价格'},
      ],
      orderOptions: [
        {value: 'minPrice / steamAvgPrice,ascending', text: '近期成交'},
        {value: 'minPrice / steamSellerPrice,ascending', text: '最优寄售'},
        {value: 'minPrice / steamBuyerPrice,ascending', text: '最优求购'},
        {value: 'minPrice / steamSafeBuyerPrice,ascending', text: '稳定成交'},
        {value: 'minPrice,ascending', text: i18n.$t('sortMinPrice')},
        {value: '(buff_staff_entity.BUYER_PRICE - minPrice)/minPrice,descending', text: '低于Buff求购'},
        {value: '(uupin_staff_entity.BUYER_PRICE - minPrice)/minPrice,descending', text: '低于UU求购'},
        {value: '(dmarket_staff_entity.ORDER_PRICE - minPrice)/minPrice,descending', text: '低于DMarket求购'},
        {value: 'minPrice / steamSellerPrice,descending', text: '第三方寄售价降序'}
      ],
      initPage: {
        wearType: '',
        weaponCase: [],
        stickerCapsule: [],
        orderBy: 'minPrice / steamBuyerPrice,ascending',
        name: '',
        minPrice: '1',
        maxPrice: '',
        total: 0,
        limit: 50,
        offset: 1,
        last24Volume: '0',
        platform: ['buff', 'c5', 'igxe', 'uupin', 'v5Item', 'waxpeer', 'skinPort', 'bitSkins', 'dmarket', 'halo', 'eco']
      },
      loading: false,
      staffList: [],
      showDetail: false,
      platformData: [],
      itemData: {},
      activeDetailTab: 0,
      detailEcharts: {},
      priceEcharts: {},
      detailEchartsOption: {
        title: {
          text: '在售量 & 近期成交'
        },
        color: ['#5470C6', '#91CC75', '#EE6666', '#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        dataZoom: [
          {
            start: 0,
            end: 100
          }
        ],
        legend: {
          data: ['steam日成交', 'steam在售', '第三方在售']
        },
        xAxis: {
          type: 'time',
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '在售量',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#5470C6'
              }
            },
            axisLabel: {
              formatter: '{value} 件'
            }
          },
          {
            type: 'value',
            name: 'steam日成交',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#91CC75'
              }
            },
            axisLabel: {
              formatter: '{value} 件'
            }
          }
        ],
        series: [
          {
            name: 'steam在售',
            type: 'bar',
            barWidth: '10',
            stack: 'onSellNumber',
            data: [
              2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
            ]
          },
          {
            name: '第三方在售',
            type: 'bar',
            barWidth: '10',
            stack: 'onSellNumber',
            itemStyle: {
              color: '#3398DB'
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          {
            name: 'steam日成交',
            symbolSize:0,
            type: 'line',
            yAxisIndex: 1,
            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
          }
        ]
      },
      priceEchartsOptions: {
        title: {
          text: '价格走势'
        },
        legend: {
          selected: {
            '参考价': true,
            'steam求购': true
          },
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'time',
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: '参考价',
            symbolSize:0,
            data: [],
            type: 'line',
            smooth: true
          },
          {
            name: 'steam求购',
            symbolSize:0,
            type: 'line',
            smooth: true,
            data: [],
            emphasis: {
              focus: 'series'
            },
          }
        ]
      },
    }
  },
  methods: {
    formatterMinPlatform(staff) {
      if (staff.minPrice === staff.buffPrice) {
        return 'BUFF'
      } else if (staff.minPrice === staff.c5Price) {
        return 'C5Game'
      } else if (staff.minPrice === staff.igxePrice) {
        return 'IGXE'
      } else if (staff.minPrice === staff.uupinPrice) {
        return '悠悠有品'
      } else if (staff.minPrice === staff.skinPortPrice) {
        return 'SkinPort'
      } else if (staff.minPrice === staff.dmarketPrice) {
        return 'DMarket'
      } else if (staff.minPrice === staff.bitSkinsPrice) {
        return 'BitSkins'
      } else if (staff.minPrice === staff.haloPrice) {
        return 'HaloSkins'
      } else if (staff.minPrice === staff.waxpeerPrice) {
        return 'Waxpeer'
      } else if (staff.minPrice === staff.ecoPrice) {
        return 'ECO'
      } else if (staff.minPrice === staff.v5ItemPrice) {
        return 'V5Item'
      }
    },
    backToPC() {
      this.$router.push('/Home')
    },
    queryItemList() {
      this.loading = true
      queryItemList(this.initPage).then(json => {
        this.staffList = json.data.data
        this.initPage.total = json.data.total
      }).finally(_ => {
        this.loading = false
      })
    },
    quickFilter(val) {
      switch (val) {
        case 'weaponCase':
          this.initPage.name = '武器箱'
          this.queryItemList()
          return;
        case 'stickerCapluse':
          this.initPage.name = '胶囊'
          this.queryItemList()
          return
        default:
          return;
      }
    },
    showDetailPopup(staff) {
      this.activeDetailTab = 0
      this.loadItemData(staff.engName)
      this.showDetail = true
    },
    loadItemData(engName) {
      auditDailyInfo({
        engName: engName
      }).then(json => {
        this.itemData = json.data.itemData
        this.platformData = json.data.platformData
        this.$nextTick(_ => {
          this.$set(this.detailEchartsOption.series[0], 'data', json.data.steamOnSells || [])
          this.$set(this.detailEchartsOption.series[1], 'data', json.data.thirdOnSells || [])
          this.$set(this.detailEchartsOption.series[2], 'data', json.data.steamVolumes || [])

          this.$set(this.priceEchartsOptions.series[0], 'data', json.data.thirdMinPrices || [])
          this.$set(this.priceEchartsOptions.series[1], 'data', json.data.steamBuyerPrices || [])

          this.detailEcharts = echarts.init(document.getElementById('detailEchartsContainer'), null, {locale: 'ZH'})
          this.priceEcharts = echarts.init(document.getElementById('priceEchartsContainer'), {locale: 'ZH'})
          this.detailEcharts.setOption(this.detailEchartsOption);
          this.priceEcharts.setOption(this.priceEchartsOptions);
        })
      })
    },
    formatterTagType(val) {
      if (val == null) {
        return ''
      }
      let disCount = this.afterFee ? val * 1.15 : val
      if (disCount <= 0.7) {
        return 'success'
      } else if (disCount <= 0.8) {
        return 'primary'
      } else if (disCount <= 0.9) {
        return 'warning'
      } else {
        return 'danger'
      }
    },
    routerChanger(url) {
      window.open(url)
    },
    formatterDmarketUrl(item) {
      let router = `https://dmarket.com/zh/ingame-items/item-list/${item.staffGame}-skins?ref=fDuhF5X91i&title=${item.engName}`;
      let exteriorArr = item.engName.match(/\(([^)]*)\)/)
      if (exteriorArr != undefined) {
        let exterior = exteriorArr[1]
        switch (exterior) {
          case 'Factory New':
            router += "&exterior=factory new"
            break
          case 'Minimal Wear':
            router += "&exterior=minimal wear";
            break
          case 'Field-Tested':
            router += "&exterior=field-tested";
            break
          case 'Well-Worn':
            router += "&exterior=well-worn";
            break
          case 'Battle-Scarred':
            router += "&exterior=battle-scarred";
            break
          default:
            break;
        }
        if (item.engName.indexOf('StatTrak™') !== -1) {
          router += '&category_0=stattrak_tm'
        } else {
          router += '&category_0=not_stattrak_tm'
        }
      }
      return router
    },
    formatSkinNameToURL(game, skinName) {
      const encodedSkinName = encodeURIComponent(skinName);
      const searchQuery = `"where":{"skin_name":"${encodedSkinName}"}`;
      const url = `https://bitskins.com/market/${game}?ref_alias=babaiwan&search={"order":[{"field":"price","order":"ASC"}],${searchQuery}}`;
      return url;
    },
  },
  created() {
    this.queryItemList()
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  text-align: center;
  background: url(../HomePage/background.jpg) 50% no-repeat;
  background-size: cover;
}

.van-card:not(:first-child) {
  margin-top: 0;
}

.van-card__content {
  min-height: 100%;
}

.van-card__thumb {
  height: 100%;
  margin-right: 8px;
  width: 105px;
}

th {
  font-weight: normal;
  font-size: 12px
}

table {
  width: 100%;
}

#table-1 thead, #table-1 tr {
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: rgb(230, 189, 189);
}

#table-1 {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: rgb(230, 189, 189);
}


/* Padding and font style */
#table-1 td, #table-1 th {
  padding: 5px;
  font-size: 12px;
  font-family: Verdana;
  color: rgb(177, 106, 104);
}


/* Alternating background colors */
#table-1 tr:nth-child(even) {
  background: #FFF
}

#table-1 tr:nth-child(odd) {
  background: rgb(238, 211, 210)
}

#table-1 tr:last-child {
  background: #FFF;
}


@font-face {
  font-family: "iconfont"; /* Project id 4419046 */
  src: url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.woff2?t=1720492860286') format('woff2'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.woff?t=1720492860286') format('woff'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.ttf?t=1720492860286') format('truetype'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.svg?t=1720492860286#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-dmarket:before {
  content: "\e6d5";
}

.icon-skinport:before {
  content: "\e6d1";
}

.icon-csmoney:before {
  content: "\e6d4";
}

.icon-steam:before {
  content: "\e6c3";
}

.icon-c5:before {
  content: "\e6c4";
}

.icon-buff:before {
  content: "\e6c5";
}

.icon-youpin:before {
  content: "\e6c6";
}

</style>



// WEBPACK FOOTER //
// src/ui/Mobile/index.vue